import dayjs from 'dayjs';

const DATE_FILTER_KEYS = ['createFrom', 'createTo'];

/**
 * History filters are kept in the store as plain strings to stay serializable,
 * while `DatePicker` and the request builders expect `dayjs` instances back.
 */
export default function castDateFilters(
  filters: Record<string, string>,
): Record<string, any> {
  return Object.fromEntries(
    Object.entries(filters).map(([key, val]) => [
      key,
      !!val && DATE_FILTER_KEYS.includes(key) ? dayjs(val) : val,
    ]),
  );
}
